import React, { useState, useEffect } from 'react';
import { Loader, Text } from '@aws-amplify/ui-react';

const Loading = (props) => {
    const [percentage, setPercentage] = useState(0);
    // console.log('Loading...')

    useEffect(() => {

        const clearID = setInterval(() => {
            setPercentage((percentage) => {
                if (percentage < 100) {
                    return percentage + 1;
                }
                return 0;
            });
        }, 50);
        return () => clearInterval(clearID);
    }, []);

    return (
        <>
            <Text>Loading {props.loadingtext}...</Text>
            <Loader size="large" percentage={percentage} isDeterminate>
            </Loader>
        </>
    )
}

export default Loading;